var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"icon-link-boxes-container",class:_vm.extraClass},_vm._l((_vm.data),function(item){return _c('icon-link-box',{key:item.id,attrs:{"data":item,"extra-class":_vm.boxExtraClass}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }